import * as types from "./actionTypes";
import * as dashboardApi from "../../../api/dashboardApi";

import { toast } from "react-toastify";
import router from "../../../core/routes/index";
import { updateUnreadMessagesCout } from "../profile/profileActions";

export function _loadDashboardHome(data) {
  return { type: types.LOAD_DASHBOARD_HOME, data };
}

export function loadReservations(data) {
  return { type: types.LOAD_RESERVATIONS, data };
}

export function userDashBoardPayments(data) {
  return { type: types.LOAD_USER_PAYMENTS, data };
}

export function loadReviews(data) {
  return { type: types.LOAD_REVIEWS, data };
}

export function loadEditReviews(data) {
  return { type: types.LOAD_EDIT_REVIEW_DETAILS, data };
}

//added from home

export function loadReviewDetailsScores(data) {
  return { type: types.LOAD_REVIEW_DETAILS_SCORES, data };
}

export function loadReviewImages(data) {
  return { type: types.LOAD_REVIEW_IMAGES, data };
}

export function loadSingleReservation(data) {
  return { type: types.LOAD_SINGLE_RESERVATION, data };
}

export function loadChats(data) {
  return { type: types.LOAD_CHATS, data };
}

export function loadNewMessage(data) {
  return { type: types.LOAD_NEW_MESSAGE, data };
}

export function unLoadNewMessage(data) {
  return { type: types.UN_LOAD_NEW_MESSAGE, data };
}

export function _updateMessageStatus(data) {
  return { type: types.UPDATE_MESSAGE_STATUS, data };
}

//added from home ends

export function loadReviewPerformance(data) {
  return { type: types.LOAD_REVIEW_PERFORMANCE, data };
}
export function loadReviewCategories(data) {
  return { type: types.LOAD_REVIEW_CATEGORIES, data };
}

//-----------> Create Review Details

export function clearReviewDetails() {
  return function (dispatch) {
    dispatch(loadEditReviews({}));
    dispatch(loadReviewDetailsScores([]));
    dispatch(loadReviewImages([]));
    dispatch(loadReviewPerformance([]));
    dispatch(loadReviewCategories([]));
  };
}

//-----------> USER PAYMENTS

export function UserDashboardPayments(payload) {
  return function (dispatch) {
    return dashboardApi
      .userPaymentsApi(payload)
      .then((result) => {
        dispatch(userDashBoardPayments(result.data));
        return result;
      })
      .catch((error) => {
        throw error;
      });
  };
}

//-----------> SEND EMAIL

//-----------> SEND SMS

export function singleReservation(id) {
  return function (dispatch) {
    return dashboardApi
      .getSingleReservationApi(id)
      .then((result) => {
        dispatch(loadSingleReservation(result?.data?.booking || {}));

        return result;
      })
      .catch((error) => {
        toast.error(error.message);
        router.navigate("/dashboard");

        throw error;
      });
  };
}

function _getWishList(data) {
  return { type: types.GET_WISHLIST, data };
}

export function getWishList(payload) {
  return function (dispatch) {
    return dashboardApi
      .getWishListApi(payload)
      .then((result) => {
        dispatch(_getWishList(result.data));
        return result;
      })
      .catch((error) => {
        throw error;
      });
  };
}

function _getNotifications(data) {
  return { type: types.GET_NOTIFICATIONS, data };
}
export function addNotification(data) {
  return { type: types.ADD_NOTIFICATION, data };
}

export function getNotifications(payload) {
  return function (dispatch) {
    return dashboardApi
      .getNotificationsApi(payload)
      .then((result) => {
        dispatch(_getNotifications(result.data));
        return result.data;
      })
      .catch((error) => {
        throw error;
      });
  };
}

export function updateNotificationStatus(data) {
  return { type: types.UPDATE_NOTIFICATION_STATUS, data };
}

export function loadDashboardHome() {
  return function (dispatch) {
    return dashboardApi
      .dashboardHomeApi()
      .then((result) => {
        const res = result?.data;

        dispatch(_loadDashboardHome(res));
        return result;
      })
      .catch((error) => {
        throw error;
      });
  };
}

export function getBookings(payload) {
  return function (dispatch) {
    return dashboardApi
      .getBookingsApi(payload)
      .then((result) => {
        dispatch(
          loadReservations({
            db_res: result.data || {},
            reservation_type:
              result.data.meta.phase ?? payload.type ?? "upcomming",
          })
        );

        return result;
      })
      .catch((error) => {
        throw error;
      });
  };
}

export function getUserReviews(payload) {
  return function (dispatch) {
    return dashboardApi
      .getReviewsApi(payload)
      .then((result) => {
        dispatch(
          loadReviews({
            db_res: result.data || {},
            type: payload.type,
          })
        );

        return result;
      })
      .catch((error) => {
        throw error;
      });
  };
}

export function loadDashboardChats(payload) {
  return function (dispatch) {
    return dashboardApi
      .chatsApi(payload)
      .then((result) => {
        const chats = result?.data?.chats || [];
        const meta = result?.data?.meta || {};
        dispatch(
          loadChats({
            chats,
            meta,
            pagination: result?.data?.pagination,
            isInitial: payload.isInitial || false,
          })
        );

        return result;
      })
      .catch((error) => {
        throw error;
      });
  };
}

export function updateDashboardChatListItem(data) {
  return { type: types.UPDATE_CHAT_LIST_ITEM, data };
}

export function sendChatMessage(data) {
  return function (dispatch) {
    dispatch(loadNewMessage(data));

    const bookingId = data.bookingId;

    return dashboardApi
      .sendMessageApi(data, bookingId)
      .then((result) => {
        return result;
      })
      .catch((error) => {
        throw error;
      });
  };
}
